import { Heading } from "@solomon-apps/shared/src/components/ui/heading";
import { ArrowShortLeftIcon } from "@solomon-labs/design/components/icons";
import { Button } from "@solomon-labs/design/components/ui";
import React from "react";
import { Link } from "react-router-dom";

import { TEAM_PATH } from "../teamData";

/**
 * The header of a page under `/team` (a member's page, Add Member): Profile's
 * heading with the way back above the title. A string title renders as the
 * page Heading; anything else (a skeleton, the Add Member name field) renders
 * as given. `status` sits beside the title, as the Programs header: below the
 * title in a narrow header, inline (gap-8) from `@xl/hdr`.
 */
export function TeamPageHeader({
    title,
    status
}: {
    title: React.ReactNode;
    status?: React.ReactNode;
}): React.ReactElement {
    return (
        <header className="@container/hdr flex flex-col gap-2 px-4 md:px-6 pb-3 md:pb-6 border-b border-line-base">
            <Button
                variant="link"
                interaction="underline"
                size="sm"
                leading={<ArrowShortLeftIcon />}
                render={<Link to={TEAM_PATH} />}
                className="self-start"
            >
                Back to Team
            </Button>
            <div className="flex flex-col items-start gap-2 @xl/hdr:flex-row @xl/hdr:items-center @xl/hdr:gap-8">
                {typeof title === "string" ? <Heading title={title} /> : title}
                {status}
            </div>
        </header>
    );
}
